const ServiceActionTypes = {
	SET_ANAGRAFICHE: 'SET_ANAGRAFICHE'
}

export default ServiceActionTypes;
